import { Record } from 'immutable';

const {
    RESOURCES_REQUEST,
    RESOURCES_SUCCESS,
    RESOURCES_FAILURE,

    CATEGORIES_REQUEST,
    CATEGORIES_SUCCESS,
    CATEGORIES_FAILURE,

    OWN_RESOURCES_REQUEST,
    OWN_RESOURCES_SUCCESS,
    OWN_RESOURCES_FAILURE,

    CREATE_RESOURCE_REQUEST,
    CREATE_RESOURCE_SUCCESS,
    CREATE_RESOURCE_FAILURE,

    UPDATE_RESOURCE_REQUEST,
    UPDATE_RESOURCE_SUCCESS,
    UPDATE_RESOURCE_FAILURE,

    DELETE_RESOURCE_REQUEST,
    DELETE_RESOURCE_SUCCESS,
    DELETE_RESOURCE_FAILURE
} = require('./resourcesActions').constants;

const InitialState = Record({
    error: null,
    isFetching: false,
    data: [],
    categories: [],
    ownResources: []
});

const initialState = new InitialState();

/**
 * ## resourcesReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function resourcesReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    case RESOURCES_REQUEST:
    case CATEGORIES_REQUEST:
    case OWN_RESOURCES_REQUEST:
    case CREATE_RESOURCE_REQUEST:
    case UPDATE_RESOURCE_REQUEST:
    case DELETE_RESOURCE_REQUEST:
        return state.set('isFetching', true)
                .set('error', null);

    case RESOURCES_SUCCESS:
        return state.set('isFetching', false)
            .set('data', payload.data);

    case CATEGORIES_SUCCESS:
        return state.set('isFetching', false)
            .set('categories', payload.data);

    case OWN_RESOURCES_SUCCESS:
        return state.set('isFetching', false)
            .set('ownResources', payload.data);

    case CREATE_RESOURCE_SUCCESS:
    case UPDATE_RESOURCE_SUCCESS:
        // TODO
        return state.set('isFetching', false);

    case DELETE_RESOURCE_SUCCESS:
        // TODO
        return state.set('isFetching', false);

    case RESOURCES_FAILURE:
    case CATEGORIES_FAILURE:
    case OWN_RESOURCES_FAILURE:
    case CREATE_RESOURCE_FAILURE:
    case UPDATE_RESOURCE_FAILURE:
    case DELETE_RESOURCE_FAILURE:
        return state.set('isFetching', false)
                .set('error', payload);

    default:
        return state;

    }
}



/** WEBPACK FOOTER **
 ** ./src/core/resources/resourcesReducer.js
 **/